// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const UsageTotals = zod.object({
  "cost_usd": zod.string(),
  "failed": zod.int(),
  "refused": zod.int(),
  "runs": zod.int(),
  "succeeded": zod.int(),
  "tokens_cached": zod.int(),
  "tokens_input": zod.int(),
  "tokens_output": zod.int()
});

export type UsageTotals = zod.input<typeof UsageTotals>;
export type UsageTotalsOutput = zod.output<typeof UsageTotals>;
